export enum NotificationDtoType {
  BulkHubJobCompleted = 'BulkHubJobCompleted',
  BulkHubJobCancelled = 'BulkHubJobCancelled',
  BulkHubJobFailed = 'BulkHubJobFailed',
}
